import { TypeScreeningTabsEnum } from '../../../interfaces/enum/TypeScreeningTabsEnum';
import './styles.css';
import DefaultTabs from '../../../components/Accessibility/DefaultTabs';

function ScreeningTabs(props: { step: number, backStep: (step: TypeScreeningTabsEnum) => void }) {

  const { step, backStep } = { ...props };

  return (
    <div style={{ marginBottom: '40px' }}>
      <DefaultTabs 
        step={step - 1} 
        stepLabels={['Queixas', 'Questionário', 'Local de exames', 'Confirmação']} 
        onTabClick={step => backStep(step + 1)} 
      />
    </div>

  );
}

export default ScreeningTabs;